import { Sparkles, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function Placeholder({ title = "Bientôt disponible", subtitle = "Cette section sera bientôt disponible.", badge = "BIENTÔT" }) {
  return (
    <div className="space-y-6 animate-fadeUp" data-testid="placeholder-page">
      <header>
        <div className="text-[10px] font-semibold uppercase tracking-[0.14em]" style={{ color: "var(--brand-purple)" }}>CDO Agency</div>
        <h1 className="font-display text-4xl font-bold tracking-tight" style={{ color: "var(--text-primary)" }}>{title}</h1>
        <p className="text-sm mt-1.5" style={{ color: "var(--text-muted)" }}>{subtitle}</p>
      </header>

      <div className="surface p-16 text-center">
        <div
          className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-5 cdo-gradient glow-purple"
          data-testid="placeholder-icon"
        >
          <Sparkles className="w-8 h-8 text-white" strokeWidth={1.6} />
        </div>
        <div className="mb-3">
          <span className="text-[10px] font-mono font-semibold uppercase tracking-wider px-2 py-1 rounded-md" style={{ background: "var(--brand-purple)20", color: "var(--brand-purple)" }}>
            {badge}
          </span>
        </div>
        <h2 className="font-display text-2xl font-bold mb-2" style={{ color: "var(--text-primary)" }}>En cours de construction</h2>
        <p className="text-sm max-w-md mx-auto mb-6" style={{ color: "var(--text-secondary)" }}>
          Cette fonctionnalité fait partie de la roadmap CDO Agency. Elle sera disponible dans une prochaine version.
        </p>
        <Link
          to="/"
          data-testid="placeholder-back"
          className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider px-4 py-2 rounded-lg transition"
          style={{ background: "var(--bg-surface-hover)", color: "var(--brand-purple)", border: "1px solid var(--border-default)" }}
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Retour au dashboard
        </Link>
      </div>
    </div>
  );
}
